<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('user_detail.contact_us')}}</h3>
            <div class="card-toolbar">
              <b-button-group>
                <b-button size="sm"><i class="far fa-file-excel mr-2"></i> Excel'e Aktar</b-button>
                <b-button size="sm"><i class="fas fa-sync mr-2"></i> Listeyi Yenile</b-button>
              </b-button-group>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-md-12">
                <b-table
                    :bordered="table.bordered"
                    :outlined="table.outlined"
                    :small="table.small"
                    :hover="table.hover"
                    :fixed="table.fixed"
                    :items="table.items"
                    :head-variant="table.headvariant"
                ></b-table>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";

export default {
  name: "ContactUs",
  components: {DataTable},
  data() {
    return {
      form : {
      },
      table : {
        bordered : true,
        outlined : true,
        small : true,
        fixed : true,
        hover : true,
        headvariant : 'light',
        items: [
          { 'ID': '88745', 'Respons': "88743", 'Status': "Tamamlandı", 'CreatedDate' : '23.11.2020','Subject': 'Siteye Giriş Sorunları', 'Message' : 'Mesaj İçeriği', 'RMessage' : 'Cevaplandı.', 'Comment' : 'tekrarlayan içerik' , 'ResponsedDate' : '28.12.2020', 'RBy' : 'Melike Saracaydin' },
          { 'ID': '88745', 'Respons': "88743", 'Status': "Tamamlandı", 'CreatedDate' : '23.11.2020','Subject': 'Siteye Giriş Sorunları', 'Message' : 'Mesaj İçeriği', 'RMessage' : 'Cevaplandı.', 'Comment' : 'tekrarlayan içerik' , 'ResponsedDate' : '28.12.2020', 'RBy' : 'Melike Saracaydin' },
          { 'ID': '88745', 'Respons': "88743", 'Status': "Tamamlandı", 'CreatedDate' : '23.11.2020','Subject': 'Siteye Giriş Sorunları', 'Message' : 'Mesaj İçeriği', 'RMessage' : 'Cevaplandı.', 'Comment' : 'tekrarlayan içerik' , 'ResponsedDate' : '28.12.2020', 'RBy' : 'Melike Saracaydin' },
          { 'ID': '88745', 'Respons': "88743", 'Status': "Tamamlandı", 'CreatedDate' : '23.11.2020','Subject': 'Siteye Giriş Sorunları', 'Message' : 'Mesaj İçeriği', 'RMessage' : 'Cevaplandı.', 'Comment' : 'tekrarlayan içerik' , 'ResponsedDate' : '28.12.2020', 'RBy' : 'Melike Saracaydin' },
          { 'ID': '88745', 'Respons': "88743", 'Status': "Tamamlandı", 'CreatedDate' : '23.11.2020','Subject': 'Siteye Giriş Sorunları', 'Message' : 'Mesaj İçeriği', 'RMessage' : 'Cevaplandı.', 'Comment' : 'tekrarlayan içerik' , 'ResponsedDate' : '28.12.2020', 'RBy' : 'Melike Saracaydin' },
          { 'ID': '88745', 'Respons': "88743", 'Status': "Tamamlandı", 'CreatedDate' : '23.11.2020','Subject': 'Siteye Giriş Sorunları', 'Message' : 'Mesaj İçeriği', 'RMessage' : 'Cevaplandı.', 'Comment' : 'tekrarlayan içerik' , 'ResponsedDate' : '28.12.2020', 'RBy' : 'Melike Saracaydin' },
        ],
      },
    }
  },
};
</script>
